import React, { useEffect, useRef } from "react";
import { GUIDE_FLOW_TABS } from "./guidesData";

function GuideFlowTabs({ activeTab, onTabChange }) {
    const tabRefs = useRef({});

    useEffect(() => {
        tabRefs.current[activeTab]?.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "nearest",
        });
    }, [activeTab]);

    return (
        <div className="sticky top-16 z-30 border-b border-slate-200 bg-[#F8F8FE]/95 py-3 backdrop-blur">
            <div className="flex justify-start overflow-x-auto overscroll-x-contain sm:justify-center">
                <div
                    role="tablist"
                    aria-label="Application guide flow"
                    className="inline-flex w-max min-w-max gap-2 rounded-xl border border-slate-200 bg-white p-1.5 shadow-sm"
                >
                    {GUIDE_FLOW_TABS.map((tab, index) => {
                        const isActive = activeTab === tab.id;

                        return (
                            <button
                                key={tab.id}
                                ref={(element) => {
                                    tabRefs.current[tab.id] = element;
                                }}
                                type="button"
                                role="tab"
                                aria-selected={isActive}
                                aria-controls="guide-content"
                                onClick={() => onTabChange(tab.id)}
                                className={`inline-flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-semibold transition-colors ${
                                    isActive
                                        ? "bg-indigo-100 text-indigo-700 shadow-sm"
                                        : "text-slate-600 hover:bg-indigo-50 hover:text-indigo-700"
                                }`}
                            >
                                <span
                                    className={`flex h-6 w-6 items-center justify-center rounded-full text-xs font-bold ${
                                        isActive
                                            ? "bg-white text-indigo-700 ring-1 ring-indigo-200"
                                            : "bg-slate-100 text-slate-500"
                                    }`}
                                >
                                    {index + 1}
                                </span>
                                <span className="whitespace-nowrap">
                                    {tab.label}
                                </span>
                            </button>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

export default GuideFlowTabs;
